import { Grid } from "@mui/material";
import ButtonEdit from "../generic/buttonEdit";
import SwitchUser from "../generic/TableSys/switchUser";
import { useNavigate } from "react-router-dom";

export default function ListUsers({ users, handleStatusParent }) {
    const navigate = useNavigate()
    return (
        <>
            {
                users.map((user, index) => (
                    <>
                        <Grid item xs={4}>
                            {user.name}
                        </Grid>
                        <Grid item xs={4}>
                            <ButtonEdit onClick={() => navigate(`/users/` + user.id)}></ButtonEdit>
                        </Grid>
                        <Grid item xs={4}>
                            <SwitchUser value={user?.status} row={user} handleStatusParent={() => handleStatusParent()}></SwitchUser>
                        </Grid>
                    </>
                ))
            }
        </>
    )
}